<template>
  <div id="midTop">
    <div class="bg-color-black">

      <div>
        <midTopChart></midTopChart>
      </div>
    </div>
  </div>
</template>
  
<script>
import midTopChart from '@/components/power/bottomMid/top'
export default {
  components: {
    midTopChart
  }
}
</script>
  
<style lang="scss" scoped>
$box-height: 300px;
$box-width: 100%;

#midTop {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;

    .active-ring-name {
      padding-top: 10px;
    }
  }
}
</style>
  